import React from 'react';
import {useNavigate} from "react-router-dom";
import {HiOutlineLocationMarker} from "react-icons/hi";
import { useCart } from '../../../context/CartContext';
import {LuSearch} from "react-icons/lu";
import { FiShoppingCart } from "react-icons/fi";
import '../../../assets/styles/_searchBar.scss'
import {FaAngleDown, FaAngleLeft} from "react-icons/fa";


const SearchBar = () => {
    const navigate = useNavigate();
    const config = window.APP_CONFIG;
    const { cart } = useCart();

    
    return (
    <section className="container-fluid rtl searchbar px-0 py-0 search-bar bg-white ">
  <div className="row g-0 search-city bg-white">

    <div className="col-12  px-4 de-menu bg-white">

     
      <div className="top-row d-flex align-items-center justify-content-between py-2">

       
        <div className="logo  rounded" style={{ cursor: 'pointer' }} onClick={() => navigate('/')}>
          <img src={config.logo_square} alt={config.title} width={40}  style={{objectFit: 'contain'}} />
        </div>

        
        <div className="search-box flex-grow-1 ms-2 me-1">
          <div className="input-wrapper d-flex align-items-center rounded px-2 py-1  bg-custom">
            <LuSearch
              className="searc-icon-bg me-2"
              style={{ fontSize: '2.1em', cursor: 'pointer' }}
              onClick={() => navigate('/search')}
            />
            <input
              type="text"
              className="form-control border-0  text-small-2 bg-custom"
              placeholder="جستجوی کالا، برند، دسته بندی"
              onClick={() => navigate('/search')}
            />
          </div>
        </div>

        
        <div className="cart-icon" onClick={() => navigate('/cart')}>
            {cart.length > 0 && (
                <span
                    className='badge bg-primary-color text-white position-absolute  translate-middle rounded-pill small'>
                   {cart.length}
                </span>
            )}
          <FiShoppingCart size={24} />

        </div>

      </div>

     
      {config.shopping_app_settings.show_city_selcet > 0 && (
        <div className="location-row  pb-2 bg-white"
             onClick={() => navigate('/select-city')}
        >
          <span
  className="location-box  align-items-center mt-2 text-small-3 "

>
  <HiOutlineLocationMarker className="location-icon  text-third-color  "  style={{fontSize: '15px'}} />
               در حال مشاهده محصولات  شهر
              {" "}
              <span className='fw-bold'>{window.localStorage.getItem('cityName') || 'همه شهرها'}</span>
              {" "}
هستید.

                    <FaAngleDown className=' text-big-1 mx-2' />
</span>

        </div>
      )}

    </div>

  </div>
</section>


    );
};

export default SearchBar;